









import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class UploadPhoto extends Vue {
  $refs!: {
    fileInput: HTMLInputElement;
  }

  @Prop({ required: false })
  protected noPreview!: boolean;

  @Prop({ required: false })
  protected value?: string;

  public trigger(): void {
    this.$refs.fileInput.click();
  }

  onFileInput(file: Event): void {
    const { files } = file.target as HTMLInputElement;
    if (!files || files.length !== 1) {
      return;
    }
    const fileReader = new FileReader();
    fileReader.onloadend = (e) => {
      this.$emit('input', e.target?.result as string);
    };
    fileReader.readAsDataURL(files[0]);
  }
}
